module.exports = __webpack_public_path__ + "static/telefonica_colour-609016f181f68df6bccd389d98b689d7.png";